import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/var/www/html/layouts/admin.vue").then(m => m.default || m)),
  auth: defineAsyncComponent(() => import("/var/www/html/layouts/auth.vue").then(m => m.default || m)),
  init: defineAsyncComponent(() => import("/var/www/html/layouts/init.vue").then(m => m.default || m)),
  member: defineAsyncComponent(() => import("/var/www/html/layouts/member.vue").then(m => m.default || m)),
  player: defineAsyncComponent(() => import("/var/www/html/layouts/player.vue").then(m => m.default || m))
}